<template>
  <header id="site-header" class="site-header" :class="{ open: isOpen }">
    <div class="content-max-width">

      <a href="/" class="logo">
        <img src="/images/logo.png" alt="Helensville" />
      </a>

      <div class="right">
        <!-- <a :href="data.phone_url" class="tel">{{data.phone}}</a>

        <a :href="data.header_btn_link" target="_blank">{{data.header_btn_title}}</a> -->
        <div class="phone desktop">
          <a :href="data.phone_url">{{data.phone}}</a>
          <span>In an emergency call 111</span>
        </div>
      </div>

    </div>

    <nav>
      <div class="content-max-width">
        <ul class="top">
          <li v-for="(link, index) of menu" :key="index">
            <a :href="link.url" :class="{ active: link.url == currentPage }">
              {{ link.title }}
            </a>
          </li>
        </ul>

        <a href="/" class="mob-logo mob">
          <img src="/images/logo.png" alt="Helensville" />
        </a>
      </div>
    </nav>

    <button class="hamburger mob" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="phone mob">
      <div class="flex items-center justify-between content-max-width">
        <a :href="data.phone_url">{{data.phone}}</a>
        <span>In an emergency call 111</span>
      </div>
    </div>

    <div class="bg mob" :class="{ open: isOpen }"></div>
  </header>
</template>

<script>
export default {
  props: {
    menu: Array,
    data: Object,
    page: String
  },

  data: () => ({
    isOpen: false,
    nav: []
  }),

  computed: {
    currentPage () {
      return window.location.href;
    },
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
